import axios from 'axios';

const geoserviceapi = axios.create( {
    baseURL: import.meta.env.TWC_GEOSERVICE_URL,
    validateStatus: function( status ) {
        return status >= 200 && status < 500;
    },
} );

export default geoserviceapi;
